require('./styles.scss');

var Top = require('./js/Index.js');


module.exports = {Top};



/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/webpack.dist.js
 **/